<div class="modal-overlay" (click)="close.emit()">
  <div class="modal-box" (click)="$event.stopPropagation()">
    <!-- Sticky / Pinned Header -->
    <div class="modal-header">
      <div class="header-content">
        <h3 class="modal-title">🎮 Remote Control: {{ deviceName || deviceId }}</h3>
        <span class="device-tag">{{ deviceId }}</span>
      </div>
      <button type="button" class="close-btn" aria-label="Close" (click)="close.emit()">&times;</button>
    </div>

    <!-- Modal Body -->
    <div class="modal-body">
      <!-- Status Box -->
      <div
        *ngIf="commandStatus"
        class="status-box"
        role="status"
        [attr.data-state]="statusState"
        data-testid="km-remote-status-box"
      >
        <span class="status-icon" *ngIf="statusState === 'sending' || statusState === 'pending'">⏳</span>
        <span class="status-icon" *ngIf="statusState === 'queued'">🕒</span>
        <span class="status-icon" *ngIf="statusState === 'completed'">✅</span>
        <span class="status-icon" *ngIf="statusState === 'failed'">❌</span>
        <span class="status-text">{{ commandStatus }}</span>
      </div>

      <!-- Log Download Link (AC-3) -->
      <div *ngIf="logDownloadUrl" class="download-container">
        <a
          class="log-download-link"
          data-testid="log-download-link"
          [href]="logDownloadUrl"
          target="_blank"
          rel="noopener"
          download
        >
          📥 Download {{ logFileName }}
        </a>
      </div>

      <!-- Action Commands: Single-Column Stack, 44px buttons (AC-4) -->
      <div class="commands-stack">
        <button
          type="button"
          class="command-btn btn-restart-app"
          data-testid="km-remote-btn-restart-app"
          (click)="onCommandClicked('RESTART_APP')"
          [disabled]="isSending"
        >
          <span class="btn-icon">🔄</span>
          <span class="btn-text">Restart App</span>
        </button>

        <button
          type="button"
          class="command-btn btn-restart-pc"
          data-testid="km-remote-btn-restart-pc"
          (click)="onCommandClicked('RESTART_PC')"
          [disabled]="isSending"
        >
          <span class="btn-icon">💻</span>
          <span class="btn-text">Restart PC</span>
        </button>

        <button
          type="button"
          class="command-btn btn-upload-logs"
          data-testid="km-remote-btn-upload-logs"
          (click)="onCommandClicked('UPLOAD_LOGS')"
          [disabled]="isSending"
        >
          <span class="btn-icon">📄</span>
          <span class="btn-text">Upload & View Logs</span>
        </button>
      </div>
    </div>

    <!-- Pinned Footer -->
    <div class="modal-footer">
      <button type="button" class="btn-close-modal" (click)="close.emit()" [disabled]="isSending">
        Close
      </button>
    </div>
  </div>

  <!-- Date Selection Prompt Dialog for Logs (AC-4) -->
  <div class="date-prompt-overlay" *ngIf="showDateDialog" (click)="$event.stopPropagation()">
    <div class="date-prompt-card">
      <div class="date-prompt-header">
        <h4 class="date-prompt-title">Select Date for AppLog</h4>
        <button type="button" class="close-btn" (click)="cancelDatePrompt()">&times;</button>
      </div>
      <div class="date-prompt-body">
        <p class="date-prompt-instruction">
          Specify the target date of the log file to pull from the kiosk:
        </p>
        <div class="date-input-container">
          <label for="logDateInput" class="date-input-label">Log Date:</label>
          <input
            type="date"
            id="logDateInput"
            [(ngModel)]="selectedLogDate"
            class="log-date-input"
            data-testid="km-remote-log-date-input"
          />
        </div>
        <div class="quick-date-buttons">
          <button type="button" class="btn-quick-date" (click)="setLogDateToday()">Today</button>
          <button type="button" class="btn-quick-date" (click)="setLogDateYesterday()">Yesterday</button>
        </div>
      </div>
      <div class="date-prompt-footer">
        <button type="button" class="btn-cancel" (click)="cancelDatePrompt()" [disabled]="isSending">
          Cancel
        </button>
        <button
          type="button"
          class="btn-fetch-log"
          data-testid="km-remote-btn-fetch-log"
          (click)="confirmDateAndFetchLog()"
          [disabled]="!selectedLogDate || isSending"
        >
          Fetch Log
        </button>
      </div>
    </div>
  </div>
</div>
